import checkPermission from './checkPermission';

const SubscriptionPlans = () => import('@/modules/subscriptionPlans');

export default [
  /*
   * Entrada da seção Much+ no menu e primeira aba ("Planos de assinatura").
   * A rota renderiza a tela direto em `/much-mais` — não é um redirect — para
   * que o item do menu seja um `router-link` de verdade e navegue sem recarregar
   * a aplicação. O destaque do item usa `$route.path.startsWith(route.path)`
   * (src/App.vue), então ancorar em `/much-mais` mantém as duas abas da seção
   * com o item destacado.
   */
  {
    path: '/much-mais',
    name: 'much-plus-subscription-plans',
    component: SubscriptionPlans,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Much+',
      menuData: {
        title: 'Much+',
        id: 'muchPlusSidebar',
        section: 'Marketing',
        icon: 'coupon',
      },
    },
  },
  /* Compatibilidade com a URL usada antes da seção ganhar abas. */
  {
    path: '/much-mais/planos-de-assinatura',
    redirect: { name: 'much-plus-subscription-plans', },
  },
];
